import { createFileRoute, Link } from '@tanstack/react-router'
import { Notebook, Plus } from 'lucide-react'
import { isFeatureEnabled } from '@/lib/feature-flags'
import { GatedFeaturePlaceholder } from '@/components/GatedFeaturePlaceholder'
import ErrorFallback from '@/components/ErrorFallback'
import { Button } from '@/components/ui/button'
import { EmptyState } from '@/components/ui/empty-state'
import { PageBody, PageContainer } from '@/components/ui/page-container'
import { PageHeader } from '@/components/ui/page-header'

export const Route = createFileRoute('/_authenticated/projects/$projectSlug/context')({
  component: ProjectContextPage,
  errorComponent: ErrorFallback,
})

export function ProjectContextPage() {
  const { projectSlug } = Route.useParams()

  if (!isFeatureEnabled('collab')) {
    return (
      <GatedFeaturePlaceholder
        title="Context Packs"
        description="Shared facts and snippets that get snapshotted into each fill, keeping the agent grounded."
        icon={Notebook}
        flagName="VITE_FF_COLLAB"
      />
    )
  }

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Project"
        title="Context Packs"
        description="Shared facts and snippets for this project. They are snapshotted into each fill."
        actions={
          <Button size="sm" variant="outline" disabled>
            <Plus />
            New pack
          </Button>
        }
      />
      <PageBody>
        <EmptyState
          icon={Notebook}
          title="No context packs yet"
          description="Create a context pack to share background facts with your team and the agent."
          action={
            <Button asChild size="sm" variant="outline">
              <Link to="/projects/$projectSlug" params={{ projectSlug }}>
                Back to project
              </Link>
            </Button>
          }
        />
      </PageBody>
    </PageContainer>
  )
}
